import { queryKeys } from '@/lib/query-keys';
import { orgMembersClient } from '@/lib/api/ts-rest';
import { createLogger } from '@/lib/logger';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';

const log = createLogger('useOrganizationMembersActions');

export function useDeleteOrganizationMember() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({
      organizationId,
      userId,
    }: {
      organizationId: string;
      userId: string;
    }) => {
      const res = await orgMembersClient.deleteMember({
        params: { organizationId, memberId: userId },
      });
      if (res.status !== 200) throw new Error('Failed to delete member');
      return res.body;
    },
    onSuccess: (_, variables) => {
      toast.success("Membre supprimé de l'organisation");
      queryClient.invalidateQueries({
        queryKey: queryKeys.organizations.members(variables.organizationId),
      });
    },
    onError: (error) => {
      log.error('Error deleting organization member', error);
      toast.error(
        'Oups, une erreur est survenue lors de la suppression du membre'
      );
    },
  });
}
